import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RmtDebugMenuComponent } from './rmt-debug-menu';

@NgModule({
  declarations: [RmtDebugMenuComponent],
  imports: [IonicPageModule.forChild(RmtDebugMenuComponent)],
  exports: [RmtDebugMenuComponent]
})
export class RmtDebugMenuComponentModule {}



// WEBPACK FOOTER //
// ./src/components/rmt-debug-menu/rmt-debug-menu.module.ts